import { Button, Col, message, Row, Space, Typography } from "antd";
import { getCookie } from "cookies-next";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CheckMark from '../../../../assets/check.svg';
import { makeApiRequest } from '../../../../shared/api';
import styles from "./style.module.scss";

const { Title, Text } = Typography;

const Complete = ({ IsAvatarId }) => {
  const [, setLoading] = useState(false);
  const navigate = useNavigate();
  const [loginButtonEnabled, setLoginButtonEnabled] = useState(false);
  const [countdown, setCountdown] = useState(5); // Initialize countdown to 5 seconds
  const loginTimeoutRef = useRef(null);
  const countdownTimerRef = useRef(null);

  const FACEBOT_ID = getCookie('fb_id');

  useEffect(() => {
    // Clear any existing timeouts/intervals
    clearTimeout(loginTimeoutRef.current);
    clearInterval(countdownTimerRef.current);

    // Set the initial state of the login button to disabled
    setLoginButtonEnabled(false);
    setCountdown(5);

    // Enable the login button after 5 seconds
    loginTimeoutRef.current = setTimeout(() => {
      setLoginButtonEnabled(true);
      clearInterval(countdownTimerRef.current); // Stop countdown when enabled
    }, 5000);

    // Countdown logic
    if (!loginButtonEnabled) {
      countdownTimerRef.current = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown > 1) {
            return prevCountdown - 1;
          } else {
            return 0; // Ensure it stays at 0 when the timer reaches 0.
          }
        });
      }, 1000);
    }

    return () => {
      // Cleanup timeouts and intervals
      clearTimeout(loginTimeoutRef.current);
      clearInterval(countdownTimerRef.current);
    };
  }, []); // Empty dependency array

  const StartGenerateBGKB = async(FACEBOT_ID) => {
    try {
      setLoading(true);
      await makeApiRequest("POST", `facebots/${FACEBOT_ID}/generate`);
      navigate("/facebot", { replace: true }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      message.error("Unable to generate background knowledge. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  const handleFinish = (FACEBOT_ID) => {
    StartGenerateBGKB(FACEBOT_ID);
    message.success("Successfully created a new facebot by existing knowledge base", 3);
  };

  return (
    <div className={styles.container}>
      <Row justify="center">
        <Col xs={24} sm={20} md={16} lg={12} xl={14}>
          <Title level={3} style={{ fontWeight: "normal" }}>
            Setup Complete
          </Title>
          <Text className={styles.description}>
            Once your avatar is ready, you'll be fully equipped to explore,
            interact, and engage with the virtual space in a way that reflects
            your style.
          </Text>
         

          <Row gutter={16} align="middle" style={{ marginTop: 40 }}>
            <Col span={10}>

              {/* Third Row */}
              <Row style={{ alignItems: "center" }}>
                <Col>
                  <Text strong>
                    <img
                      src={CheckMark}
                      alt=""
                      style={{ verticalAlign: "middle", marginRight: 8, filter: 'invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)' }}
                    />
                    Creating FaceBot
                  </Text>
                </Col>
              </Row>
            </Col>
            <br style={{ marginTop: 16 }} />

            <Text type="danger" style={{ marginTop: 16 }}>
            Almost there! Your FaceBot is being prepared and will be ready in
            approximately 10-15 minutes. Keep an eye on your inbox for an email
            when it's complete.
            </Text>
          </Row>
        </Col>
        
      </Row>

      
      <div
        style={{ maxWidth: 850, margin: "auto", padding: 20, marginTop: 40 }}
      >
        <Space>
          <Button
            size="large"
            type="primary"
            // style={{ width: "10rem" }}
            onClick={() => handleFinish(FACEBOT_ID)}
            disabled={!loginButtonEnabled}
          >
           Create Facebot {loginButtonEnabled ? "" : `(${countdown})`}
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default Complete;